import React, { useEffect, useState } from "react"
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from "@material-ui/core"
import ClearIcon from '@material-ui/icons/Clear'
import mainStyles from '../WorkerManagementComponent/WorkerManagementComponent.module.css'
import formStyles from '../TeamsManagement/styles.module.css'
import styles from './styles.module.css'
import { BlueBtn, BlueInverseBtn } from "../Styled/StyledButtons"

interface IProps {
    show: boolean
    toggleHandle: () => void
    onSubmit: (phone: string, comment: string) => void
}

/**
 * Add one of our DIDs to the exemption list.
 *
 * Free text rather than a masked input, because the number is pasted from Twilio, from a
 * ticket or from a spreadsheet in whatever shape that source used, and the API normalises
 * anyway. The shape check below is the same rule the API applies, so an obviously wrong
 * number is caught here instead of round-tripping for a 422.
 */
const AddDestination = (props: IProps) => {
    const [phone, setPhone] = useState('')
    const [comment, setComment] = useState('')

    // Reset between openings, otherwise the previous entry's reason is pre-filled and gets
    // attached to a different number.
    useEffect(() => {
        if (props.show) {
            setPhone('')
            setComment('')
        }
    }, [props.show])

    const digits = phone.replace(/\D/g, '')
    const normalized = digits.length === 11 && digits.charAt(0) === '1' ? digits.slice(1) : digits
    const phoneValid = /^[2-9][0-9]{2}[2-9][0-9]{6}$/.test(normalized)
    const commentValid = comment.trim().length > 3
    const valid = phoneValid && commentValid

    const submit = () => {
        if (!valid) {
            return
        }
        props.onSubmit('+1' + normalized, comment.trim())
        props.toggleHandle()
    }

    return (
        <Dialog open={props.show} onClose={props.toggleHandle} maxWidth="sm" fullWidth={true}>
            <DialogTitle>
                Exempt a number from spam filtering
                <IconButton className={mainStyles.floatRight} onClick={props.toggleHandle}>
                    <ClearIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={formStyles.popup}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <label className={formStyles.FormLabel}>Number (one of ours)</label>
                        <input
                            placeholder="+1 805 892 6988"
                            className={`${(!phoneValid && phone !== '') ? formStyles.FormInvalid : ""} ${formStyles.FormControl}`}
                            value={phone}
                            onChange={(event) => setPhone(event.target.value)}
                        />
                        {(!phoneValid && phone !== '') ?
                            <div className={styles.Hint}>
                                Needs to be a US/Canada number. Any format is fine — it is
                                normalised before it is stored.
                            </div>
                            : null}
                    </Grid>
                    <Grid item xs={12}>
                        <label className={formStyles.FormLabel}>Reason (required)</label>
                        <input
                            placeholder="Why must no filter reject on this number?"
                            className={`${(!commentValid && comment !== '') ? formStyles.FormInvalid : ""} ${formStyles.FormControl}`}
                            value={comment}
                            onChange={(event) => setComment(event.target.value)}
                        />
                        <div className={styles.Hint}>
                            Recorded against your user. If this number was exempt before, its
                            earlier history is kept and this becomes the latest entry.
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <BlueInverseBtn fullWidth={true} onClick={props.toggleHandle}>Cancel</BlueInverseBtn>
                    </Grid>
                    <Grid item xs={6}>
                        <BlueBtn fullWidth={true} disabled={!valid} onClick={submit}>Exempt</BlueBtn>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default AddDestination
